<template>
  <div>
    <!--面包屑-->
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: '/Home' }">首页 </el-breadcrumb-item>
      <el-breadcrumb-item>网授课程</el-breadcrumb-item>
      <el-breadcrumb-item>网课列表</el-breadcrumb-item>
    </el-breadcrumb>

    <!--卡片区域-->
    <el-card class="box-card">
      <el-row :gutter="20" type="flex" align="middle">
        <el-col :span="20">
          <el-form :inline="true" class="searchDiv">
            <el-form-item label="关键词">
              <el-input
                clearable
                placeholder="搜索关键词"
                v-model="searchKey"
              ></el-input>
            </el-form-item>
            <el-form-item label="试卷ID">
              <el-input
                clearable
                placeholder="搜索试卷ID"
                v-model="shijuan_id"
              ></el-input>
            </el-form-item>
            <el-form-item label="课程ID">
              <el-input
                clearable
                placeholder="搜索课程ID"
                v-model="kc_id"
              ></el-input>
            </el-form-item>
            <el-form-item label="课程类别">
              <el-input
                clearable
                placeholder="搜索课程类别"
                v-model="kc_group"
              ></el-input>
            </el-form-item>
            <el-form-item label="有无证书">
              <el-select v-model="has_cert" clearable placeholder="请选择">
                <el-option
                  v-for="(item2, index2) in validArr"
                  :key="index2"
                  :label="item2"
                  :value="index2"
                >
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="继续教育学分课">
              <el-select v-model="is_jixujiaoyu" clearable placeholder="请选择">
                <el-option
                    v-for="(item2, index2) in is_jixujiaoyuArr"
                    :key="index2"
                    :label="item2"
                    :value="index2"
                >
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="可否拉动进度条">
              <el-select v-model="can_progress" clearable placeholder="请选择">
                <el-option
                    v-for="(item2, index2) in ['否','是']"
                    :key="index2"
                    :label="item2"
                    :value="index2"
                >
                </el-option>
              </el-select>
            </el-form-item>

          </el-form>
        </el-col>
        <el-col :span="2">
          <el-button size="mini" round type="success" @click="onSubmit"
            >搜索</el-button
          >
        </el-col>
        <el-col :span="2">
          <el-button size="mini" round type="warning" @click="onAdd"
            >新增</el-button
          >
        </el-col>
      </el-row>
      <!--用户列表区 -->
      <div class="table">
        <el-table
          :data="tableData"
          :border="true"
          :height="getH()"
          stripe
          :resizable="true"
        >
          <el-table-column
            show-overflow-tooltip
            v-for="(item, index) in propList"
            :key="index"
            :prop="item.prop"
            :label="item.label"
            :width="item.width ? item.width : 100"
          >
            <template slot-scope="scope">
              <div v-if="item.type == 'array'">
                {{ getOptionVal(item.data, scope.row[item.prop]) }}
              </div>
              <div v-else-if="item.type == 'arrayObj'">
                {{ getOptionVal(item.data, scope.row[item.prop], item.type) }}
              </div>
              <!--显示首页列表图1-->
              <div
                v-else-if="
                  scope.column['property'] == 'tImg1' ||
                  scope.column['property'] == 'tImg2' ||
                  scope.column['property'] == 'jieye_pic' ||
                  scope.column['property'] == 'desc_pic' ||
                  scope.column['property'] == 'play_pic'
                "
              >
                <el-image
                  v-if="scope.row[scope.column['property']]"
                  :src="$getUrl(scope.row[scope.column['property']])"
                  fit="scale-down"
                  style="height: 100px"
                />
              </div>

              <!--
              <el-image
                v-else-if="scope.column['property'] == 'tImg2'"
                :src="scope.row['tImg2_val']"
                fit="cover"
                height="100"
              />
        
              <el-image
                v-else-if="scope.column['property'] == 'jieye_pic'"
                :src="scope.row['jieye_pic_val']"
                fit="cover"
                height="100"
              />
             
              <el-image
                v-else-if="scope.column['property'] == 'desc_pic'"
                :src="scope.row['desc_pic_val']"
                fit="cover"
                style="width:100px;height:100px;"
                
              />
              
              <el-image
                v-else-if="scope.column['property'] == 'play_pic'"
                :src="scope.row['play_pic_val']"
                fit="cover"
                height="100"
              />
-->
              <div v-else>
                {{ scope.row[scope.column["property"]] }}
              </div>
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="操作" width="120">
            <template slot-scope="scope">
              <div class="caoz">
                <el-button
                  type="text"
                  size="small"
                  @click="onEditItem(scope.row)"
                  >编辑</el-button
                >
                <el-button
                  type="text"
                  size="small"
                  @click="onDelItem(scope.row)"
                >
                  删除</el-button
                >
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!--分页区-->
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page"
        :page-sizes="[10, 30, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </el-card>

    <!--编辑窗口-->
    <el-dialog
      v-if="showEditDlg"
      :close-on-click-modal="false"
      :title="!editItem.id ? '新增' : '编辑'"
      :visible.sync="showEditDlg"
      width="300"
      :before-close="handleCloseDlg"
    >
      <el-form :inline="false" label-width="150px">
        <el-row>
          <el-col
            class="myElCol"
            :span="11"
            v-for="(item, index) in propList"
            :key="index"
          >
            <el-form-item :label="item.label">
              <el-select
                v-if="item.type == 'array'"
                v-model="editItem[item.prop]"
                placeholder="请选择"
              >
                <el-option
                  v-for="(item2, index2) in item.data"
                  :key="index2"
                  :label="item2"
                  :value="index2"
                >
                </el-option>
              </el-select>
              <el-select
                v-else-if="item.type == 'arrayObj'"
                v-model="editItem[item.prop]"
                placeholder="请选择"
              >
                <el-option
                  v-for="(item2, index2) in item.data"
                  :key="index2"
                  :label="item2.title"
                  :value="item2.val"
                >
                </el-option>
              </el-select>
              <el-select
                v-else-if="item.prop == 'power'"
                v-model="editItem[item.prop]"
                :collapse-tags="false"
                multiple
                placeholder="请选择"
              >
                <el-option
                  v-for="(item2, index2) in powerList"
                  :key="index2"
                  :label="item2"
                  :value="item2"
                >
                </el-option>
              </el-select>

              <el-date-picker
                v-else-if="item.type == 'time'"
                v-model="editItem[item.prop]"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="选择日期时间"
              >
              </el-date-picker>
              <el-input
                v-else
                :type="item.type == 'textarea' || item.type == 'pic' ? 'textarea' : 'text'"
                :disabled="item.prop == 'id'"
                :rows="2"
                clearable
                v-model="editItem[item.prop]"
              >
              </el-input>
              <MyUploadPlus
                v-if="
                  item.type == 'pic'
                "
                accept="*"
                :disabled="false"
                @urlChange="(e) => onUrlChange(item.prop, e)"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showEditDlg = false">取 消</el-button>
        <el-button type="primary" @click="onSaveEdit">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>


<script>
export default {
  data() {
    return {
      //当前的页数
      page: 1,
      //当前的页码显示的条数
      pageSize: 10,
      //最后页号
      last_page: 0,

      searchKey: "",
      shijuan_id: "",
      kc_id: "",
      has_cert: "",
      kc_group: "",
      is_jixujiaoyu:'',
      can_progress:'',
      //是否有证书
      validArr: ["无", "有"],
      is_jixujiaoyuArr: ["否", "是"],
      //用户数据列表 默认为空
      tableData: [],
      //总数据条数
      total: 0,
      /**
       * 
  `id` int(11) NOT NULL AUTO_INCREMENT,
  `kc_id` int(11) NOT NULL DEFAULT '0' COMMENT '跳转课程ID',
  `order_id` int(11) NOT NULL DEFAULT '0' COMMENT '排序ID',

  `title` varchar(255) NOT NULL DEFAULT '' COMMENT '课程短标题',

  `jieye_pic` varchar(255) NOT NULL DEFAULT '' COMMENT '结业证申请流程图',
  `desc_pic` varchar(255) NOT NULL DEFAULT '' COMMENT '课程介绍图',
  `money` decimal(11,2) NOT NULL DEFAULT '0.00' COMMENT '价格',
  `jmp_url` varchar(255) NOT NULL DEFAULT '' COMMENT '跳转Url',
  `kc_name` varchar(255) NOT NULL DEFAULT '' COMMENT '课程长标题',
  `play_pic` varchar(255) NOT NULL DEFAULT '' COMMENT '播放器图片',
  `kc_group` varchar(255) NOT NULL DEFAULT '' COMMENT '课程类别(Ⅰ类,Ⅱ类,Ⅲ类)',
  `pay_type` int(11) NOT NULL DEFAULT '0' COMMENT '付费类型(0:先付后学 1:先学后付 )',
  `other_msg` varchar(255) NOT NULL DEFAULT '' COMMENT '名称附加说明',
  `shijuan_id` int(11) NOT NULL DEFAULT '0' COMMENT '试卷ID',
  `has_cert` int(11) NOT NULL DEFAULT '0' COMMENT '是否有证书(0=无 1=有)',
  `xmbh` varchar(255) NOT NULL DEFAULT '' COMMENT '项目编号',
  `kao_type` int(11) NOT NULL DEFAULT '1' COMMENT '考核类型 1-普通考核 2-面对面考核 ',
  `kc_starTime` date DEFAULT NULL COMMENT '培训开始时间',
  `kc_endTime` date DEFAULT NULL COMMENT '培训结束时间',
  `kao_starTime` timestamp NULL DEFAULT NULL COMMENT '考试开始时间戳',
  `kao_endTime` timestamp NULL DEFAULT NULL COMMENT '考试开始结束戳',
  `kao_examnum` int(11) NOT NULL DEFAULT '0' COMMENT '答题时限分钟',
  `kao_total` int(11) NOT NULL DEFAULT '0' COMMENT '考试总分数',
  `kao_hege` int(11) NOT NULL DEFAULT '0' COMMENT '考试及格分',
  `kao_bukao` int(11) NOT NULL DEFAULT '0' COMMENT '考试补考次数',
  `kao_timunum` int(11) NOT NULL DEFAULT '0' COMMENT '考试题目数',
  `kao_questionway` int(11) NOT NULL DEFAULT '1' COMMENT '考试出题方式(1=顺序 2=随机)',
       `show_bili` int(11) NOT NULL DEFAULT '1' COMMENT '显示合格比例(0=不显示 1=显示)',
       `is_jixujiaoyu` int(11) NOT NULL DEFAULT '0' COMMENT '是否继续教育学分课(0=否 1=是)',
  `can_progress` int(11) NOT NULL DEFAULT '0' COMMENT '能否拉动进度条',
  PRIMARY KEY (`id`) USING BTREE
       * 
       */
      propList: [
        {
          prop: "id",
          label: "ID",
        },

        {
          prop: "kc_id",
          label: "课程ID",
        },
        
        {
          prop: "order_id",
          label: "排序ID(从小到大)",
           width: 150,
        },
        {
          prop: "title",
          label: "课程短标题",
          width: 250,
        },
        {
          prop: "can_progress",
          label: "可否拉动进度条",
          type: "array",
          data: ["否", "是"],
        },
        {
          prop: "jieye_pic",
          label: "结业证申请流程图",
          width: 200,
          type: 'pic'
        },
        {
          prop: "desc_pic",
          label: "课程介绍图",
          width: 200,
          type: 'pic'
        },
        {
          prop: "money",
          label: "价格",
        },
        {
          prop: "jmp_url",
          label: "跳转Url",
        },
        {
          prop: "kc_name",
          label: "课程长标题",
          width: 200,
        },
        {
          prop: "play_pic",
          label: "播放器图片",
          width: 200,
          type: 'pic'
        },
        {
          prop: "kc_group",
          label: "课程类别(Ⅰ类,Ⅱ类,Ⅲ类)",
          width: 200,
        },
        {
          prop: "pay_type",
          label: "付费类型",
          type: "array",
          data: ["先付后学", "先学后付"],
        },
        {
          prop: "other_msg",
          label: "名称附加说明",
          width: 200,
        },
        {
          prop: "shijuan_id",
          label: "试卷ID",
        },

        {
          prop: "has_cert",
          label: "有无证书",
          type: "array",
          data: ["无", "有"],
        },
        {
          prop: "xmbh",
          label: "项目编号",
        },
        {
          prop: "kao_type",
          label: "考核类型",
          type: "arrayObj",
          data: [
            {
              title: "普通考核",
              val: 1,
            },
            {
              title: "面对面考核",
              val: 2,
            },
          ],
        },
        {
          prop: "kc_starTime",
          label: "培训开始时间",
          width: 200,
        },
        {
          prop: "kc_endTime",
          label: "培训结束时间",
          width: 200,
        },
        {
          prop: "kao_starTime",
          label: "考试开始时间戳",
          width: 200,
        },
        {
          prop: "kao_endTime",
          label: "考试开始结束戳",
          width: 200,
        },
        {
          prop: "kao_examnum",
          label: "答题时限分钟",
          width: 120,
        },
        {
          prop: "kao_total",
          label: "考试总分数(自动)",
        },
        {
          prop: "kao_hege",
          label: "考试及格分",
        },
        {
          prop: "kao_bukao",
          label: "考试补考次数",
          width: 120,
        },
        {
          prop: "kao_timunum",
          label: "考试题目数(自动)",
        },
        {
          prop: "kao_questionway",
          label: "考试出题方式",
          type: "array",
          data: ["顺序", "随机"],
          width: 200,
        },
        {
          prop: "show_bili",
          label: "显示合格比例",
          type: "array",
          data: ["否", "是"],
          width: 200,
        },
        {
          prop: "is_jixujiaoyu",
          label: "继续教育学分课",
          type: "array",
          data: ["否", "是"],
          width: 200,
        },
      ],
      //当前编辑项目内容
      editItem: {},
      //显示编辑窗口
      showEditDlg: false,
      //所有权限列表
      powerList: [],
    };
  },
  created() {
    //窗体大小变化就执行getH方法
    window.addEventListener("resize", this.getH);

    this.getList();
  },

  methods: {
    //调整table 高度
    getH() {
      return window.innerHeight - 350;
    },
    handleCloseDlg() {
      console.log("handleCloseDlg");
      this.showEditDlg = false;
    },

    //获取列表
    async getList() {
      let obj = {
        page: this.page,
        pageSize: this.pageSize,
        searchKey: this.searchKey,
        shijuan_id: this.shijuan_id,
        kc_id: this.kc_id,
        has_cert: this.has_cert,
        kc_group: this.kc_group,
        is_jixujiaoyu:this.is_jixujiaoyu,
        can_progress:this.can_progress
      };
      const res = await this.$post(`KcList/getList`, obj);
      console.log(res);
      if (res.code !== 200) return;

      this.tableData = res.data.data;
      //获取特殊字段值
      for (let i in this.tableData) {
        // //显示首页列表图1-
        // if (this.tableData[i]["tImg1"].length > 0) {
        //   this.tableData[i]["tImg1_val"] =
        //     this.$imgUrl + this.tableData[i]["tImg1"];
        // }
        //
        // //显示首页列表图2-
        // if (this.tableData[i]["tImg2"].length > 0) {
        //   this.tableData[i]["tImg2_val"] =
        //     this.$imgUrl + this.tableData[i]["tImg2"];
        // }
        //显示首结业证申请流程图
        if (this.tableData[i]["jieye_pic"].length > 0) {
          this.tableData[i]["jieye_pic_val"] =
            this.$imgUrl + this.tableData[i]["jieye_pic"];
        }

        //显示课程介绍图-
        if (this.tableData[i]["desc_pic"].length > 0) {
          this.tableData[i]["desc_pic_val"] =
            this.$imgUrl + this.tableData[i]["desc_pic"];
        }
        //显示播放器图片-
        if (this.tableData[i]["play_pic"].length > 0) {
          this.tableData[i]["play_pic_val"] =
            this.$imgUrl + this.tableData[i]["play_pic"];
        }
      }
      this.total = res.data.total;
    },

    //监听 pagesize 改变的事件
    handleSizeChange(newSize) {
      //console.log(newSize)
      this.pageSize = newSize;
      this.getList();
    },

    //监听 页码值 改变的事件
    handleCurrentChange(newPage) {
      //console.log(newPage)
      this.page = newPage;
      //获取用户列表数据
      this.getList();
    },
    //点击搜索显示搜索内容
    onSubmit() {
      this.getList();
    },
    // 展示编辑角色对话框 Dialog:对话框
    onEditItem(item) {
      this.editItem = JSON.parse(JSON.stringify(item));

      this.showEditDlg = true;
    },

    onAdd() {
      console.log("onAdd");
      let obj = {};
      for (let i in this.propList) {
        let prop = this.propList[i]["prop"];
        this.$set(obj, prop, "");
      }
      this.editItem = obj;
      this.showEditDlg = true;
    },
    //点击确定保存信息
    async onSaveEdit() {
      let obj = {
        id: this.editItem.id,
        data: this.editItem,
      };

      const res = await this.$post(`KcList/saveData`, obj);
      console.log(res);
      this.showEditDlg = false;
      if (res.code !== 200) return;
      this.$ok(res.msg);
      this.getList();
    },
    //点击删除弹出对话框是否真的删除
    async onDelItem(item) {
      //弹出对话框是否真的删除 此操作将永久删除该信息
      const confirmResult = await this.$confirm(
        "此操作将永久删除该信息?",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).catch((err) => err);
      //如果用户确认删除,则返回值为字符串  confirm
      //如果用户取消删除,则返回值为字符串  cancel
      //console.log( confirmResult );
      if (confirmResult !== "confirm") {
        return this.$info("已取消删除");
      }
      let obj = {
        id: item.id,
      };
      console.log(obj);
      const res = await this.$post(`KcList/delItem`, obj);
      console.log("确认删除", res);
      if (res.code !== 200) return;
      this.$ok(res.msg);
      this.getList();
    },
    onUrlChange(fielddName, e) {
      console.log("获取 getUrlChange", fielddName, e);
      this.editItem[fielddName] = e[0].url;
    },
  },
};
</script>

<style lang="less" scoped>
.mybtn {
  display: flex;
  justify-content: flex-end;
}

.jifen {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.dialog-footer {
  display: flex;
  justify-content: flex-end;
}
</style>
